// eslint-disable-next-line import/no-cycle
import Content from './Content.component';

export default Content;
